import React from "react";

const AddStaff = () => {
  return (
    <>
      <div className="d-flex justify-content-end mt-5">
        <div className="form-header">
          <section className="piechartsBox_area">
            {/* <BackPageBtn backLink="/" /> */}

            <form>
              <div>
                <h1 style={{ color: "#ff9c00" }}>Add Staff</h1>
              </div>

              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="name"
                    // value={formValue?.document}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Address</label>
                  <textarea
                    style={{ resize: "none" }}
                    type="text"
                    className="form-control h-75"
                    placeholder="Enter Address"
                    name="address"
                    // value={formValue?.document}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Phone Number"
                    name="phoneNumber"
                    // value={formValue?.document}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    // value={formValue?.document}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password"
                    name="password"
                    // value={formValue?.document}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>

              {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}
              <div class="col-12 ">
                <button
                  type="submit"
                  //   onClick={(e) => handleSubmit(e)}
                  class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  Add
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddStaff;
